import { AppHttpClient } from 'common/core/http/app-http-client.service';
import * as i0 from "@angular/core";
import * as i1 from "../../../common/core/http/app-http-client.service";
var Projects = /** @class */ (function () {
    function Projects(http) {
        this.http = http;
    }
    /**
     * Get all available projects.
     */
    Projects.prototype.all = function (params) {
        return this.http.get('projects', params);
    };
    /**
     * Get project matching specified id.
     */
    Projects.prototype.get = function (id) {
        return this.http.get('projects/' + id);
    };
    /**
     * Create a new project.
     */
    Projects.prototype.create = function (params) {
        return this.http.post('projects', params);
    };
    /**
     * Update project matching specified id.
     */
    Projects.prototype.update = function (id, params) {
        return this.http.put('projects/' + id, params);
    };
    /**
     * Delete project matching specified id.
     */
    Projects.prototype.delete = function (params) {
        return this.http.delete('projects', params);
    };
    /**
     * Create or update specified project's thumbnail image.
     */
    Projects.prototype.generateThumbnail = function (projectId, dataUrl) {
        return this.http.post('projects/' + projectId + '/generate-thumbnail', { dataUrl: dataUrl });
    };
    /**
     * Publish specified project to FTP.
     */
    Projects.prototype.publish = function (projectId, params) {
        return this.http.post('projects/' + projectId + '/publish', params);
    };
    Projects.ngInjectableDef = i0.defineInjectable({ factory: function Projects_Factory() { return new Projects(i0.inject(i1.AppHttpClient)); }, token: Projects, providedIn: "root" });
    return Projects;
}());
export { Projects };
